<template>
  <div id="track-card" v-if="!isNpsFiredForOrder">
    <div v-if="isOrderStatusBeforeDelivery" class="active-order-card p16">
      <observer
        :keepConnectedOnIntersection="true"
        :emitNotIntersecting="true"
        :options="{ root: null, threshold: 0.5, rootMargin: '0%' }"
        @intersect="cardObserved"
        @notIntersecting="cardUnobserved"
      />
      <div
        v-if="isCurrentOrder"
        class="flex-row justify-content-between width100"
      >
        <div class="flex-column align-items-start tl">
          <div class="active-order-card-info fs-12">
            Order #<span>{{ order?.store?.orderId }} </span> •
            <span>{{ order?.items?.length }}</span>
            <span v-if="order?.items?.length > 1" class="color-slaty fs-11"
              >&nbsp;Items</span
            >
            <span v-else class="color-slaty fs-11">&nbsp;Item</span> • ₹{{
              order?.netPrice
            }}
          </div>
          <div class="active-order-card-time mb12">
            <div
              class="fs-11 fw-800 active-order-card-on-time"
              :class="[timeStatusTagBgColorClass, timeStatusTagFontColorClass]"
            >
              <i v-if="showBoltIcon" class="hkfi-bolt-icon fs-12 mr3" />{{
                timeStatusValue
              }}
            </div>
            <span class="active-order-card-arrive-text fs-12">Arriving in</span>
            <span class="time fs-14 fw-800">{{ etaTime }} min</span>
          </div>
          <div class="active-order-card-desc fs-16 fw-700">
            {{ timeLineText }}
          </div>
        </div>
        <div class="flex-column align-items-flex-end">
          <i
            class="hkfi-expand fs-24 icon-fixed color-slaty"
            @click="sendToTrackingPage"
          />
          <div class="active-order-card-image mt12" v-if="getOrderStatusImgUrl">
            <img :src="getOrderStatusImgUrl" class="active-order-card-image" />
          </div>
        </div>
      </div>
      <progress-bar
        v-if="!isOrderDelivered && isCurrentOrder"
        :percent="progressBarPercent"
      ></progress-bar>
      <!-- <div
        v-if="isCurrentOrder"
        class="inline-flex justify-content-between w100 pt12"
      >
        <div>{{ bottomText }}</div>
        <i
          v-if="!isOrderDelivered"
          class="hkfi-arrow-line"
          @click="sendToTrackingPage"
        />
      </div> -->

      <active-order-card-shimmer v-if="!isCurrentOrder" />
    </div>
    <pre-delivery-order-card
      :data-results="dataResults"
      :activateOrderCardClick="true"
      :index="index"
      :data-props="dataProps"
      v-if="isOrderOnGate"
    />
    <post-delivery-order-card
      :data-results="dataResults"
      :activateOrderCardClick="true"
      :index="index"
      :data-props="dataProps"
      v-if="isOrderDelivered"
    />
  </div>
</template>

<script>
import get from "lodash/get";
import { keyMapsAction } from "../helpers/storeKeys";
import { clientPlatform, staticImgBaseUrl } from "../config/apiEndpoints";
import ProgressBar from "./reusableComponents/ProgressBar.vue";
import Observer from "./Observer.vue";
import ActiveOrderCardShimmer from "./ActiveOrderCardShimmer.vue";
import PreDeliveryOrderCard from "./PreDeliveryOrderCard.vue";
import PostDeliveryOrderCard from "./PostDeliveryOrderCard.vue";
import Utility from "../helpers/utility";
import LocalStorageFunc from "../helpers/localStorageFunc";

import {
  OrderStatusTimelineTextForDelivery,
  OrderStatusHelpBottomTextForDeliveryKey,
  OrderStatusImgIconKey,
  TimeStatusTagBgColorClass,
  TimeStatusTagFontColorClass,
  ShowBoltIcon,
} from "../helpers/OrderStatusConstants";

export default {
  name: "ActiveOrderCard",
  components: {
    ProgressBar,
    Observer,
    ActiveOrderCardShimmer,
    PostDeliveryOrderCard,
    PreDeliveryOrderCard,
  },
  props: {
    dataResults: { required: false, default: "" },
    sourcePage: { required: false, default: "" },
    activateOrderCardClick: { required: false, default: false },
    index: { required: false, default: 0 },
    dataProps: { required: true, default: {} },
  },
  data() {
    return {
      staticImgBaseUrl,
      clientPlatform,
      animationInstance: {},
      modulePropsData: {},
      inView: false,
      order: {},
      limit: 3,
      ratingTags: {},
      moduleProps: {},
      startPolling: false,
    };
  },
  mounted() {
    this.order = this.dataResults;
    this.moduleProps = this.dataProps;
  },
  methods: {
    cardObserved() {
      if (this.isAlreadyDelivered) return;
      this.startPolling = true;
      setTimeout(() => {
        this.$store.dispatch(keyMapsAction.POST_ORDER_TRACKER_API, {
          orderId: this.order?.id,
        });
        this.pollData();
      }, 60);
    },
    cardUnobserved() {
      this.startPolling = false;
    },
    pollData() {
      if (this.startPolling && !this.isAlreadyDelivered) {
        setTimeout(() => {
          if (
            this.isCurrentOrder &&
            !this.isOrderDelivered &&
            !this.isAlreadyDelivered
          ) {
            this.$store.dispatch(keyMapsAction.POST_ORDER_TRACKER_API, {
              orderId: this.order?.id,
            });
            this.pollData();
          }
        }, 60000);
      }
    },
    sendToTrackingPage() {
      LocalStorageFunc.setOrderId(this.order?.id);
      LocalStorageFunc.setOrderSummary(this.order);
      setTimeout(() => {
        Utility.sendToOrderTracking();
      }, 10);
    },
  },
  computed: {
    currentOrderState() {
      return this.isCurrentOrder && this.postOrderTrackerResponse?.orderStatus
        ? this.postOrderTrackerResponse?.orderStatusCode
        : this.order?.orderCurrentState;
    },
    progressBarPercent() {
      return this.isCurrentOrder && this.postOrderTrackerResponse?.orderStatus
        ? this.eta.progress
        : this.currentOrderState * 10;
    },
    timeLineText() {
      return this.isCurrentOrder && this.postOrderTrackerResponse?.orderStatus
        ? this.orderTrackingMessages?.statusMessage
        : OrderStatusTimelineTextForDelivery[this.currentOrderState];
    },
    bottomText() {
      return get(
        this.moduleProps,
        OrderStatusHelpBottomTextForDeliveryKey[this.currentOrderState],
        "",
      );
    },
    postOrderTrackerResponse() {
      return this.$store.state.OrderTracking?.postOrderTrackerResponse;
    },
    eta() {
      return this.postOrderTrackerResponse?.etaWidget?.eta;
    },
    etaTime() {
      return this.eta?.eta;
    },
    timeStatusValue() {
      return this.eta?.timeStatusValue;
    },
    orderTrackingMessages() {
      return this.postOrderTrackerResponse?.etaWidget?.orderTrackingMessages;
    },
    isCurrentOrder() {
      return (
        this.order.id == this.$store.state.OrderTracking?.currentTrackerOrderId
      );
    },
    isOrderDelivered() {
      return this.currentOrderState == 9;
    },
    isAlreadyDelivered() {
      return this.$store.state.OrderTracking.deliveredOrderIds.includes(
        this.order?.id,
      );
    },
    isNpsFiredForOrder() {
      return this.$store.state.OrderTracking.npsFiredOrderIds.includes(
        this.order?.id,
      );
    },
    isOrderOnGate() {
      return this.currentOrderState == 10;
    },
    isOrderStatusBeforeDelivery() {
      return !this.isOrderDelivered && !this.isOrderOnGate;
    },
    getOrderStatusImgUrl() {
      return get(
        this.moduleProps,
        OrderStatusImgIconKey[this.currentOrderState],
        "",
      );
    },
    timeStatusTagBgColorClass() {
      return TimeStatusTagBgColorClass[this.eta?.timeStatus];
    },
    timeStatusTagFontColorClass() {
      return TimeStatusTagFontColorClass[this.eta?.timeStatus];
    },
    showBoltIcon() {
      return ShowBoltIcon[this.eta?.timeStatus];
    },
  },
};
</script>
